export default [
	{
		path: '/agreement/service',
		name: 'AgreementService',
		component: () => import('@/views/agreement/service.vue'),
		meta: { title: '服务协议' }
	},
	{
		path: '/agreement/privacy',
		name: 'AgreementPrivacy',
		component: () => import('@/views/agreement/privacy.vue'),
		meta: { title: '隐私协议' }
	}
]
